export default function Features() {
  const features = [
    {
      title: 'Military-Grade Encryption',
      label: 'Security',
      description: 'Protect your data with advanced encryption protocols',
      image: 'https://public.readdy.ai/ai/img_res/b5d3f41ae116fb1263bc7bf8dac89a51.jpg'
    },
    {
      title: 'Lightning Fast Performance',
      label: 'Performance',
      description: 'Optimized for speed without compromising quality',
      image: 'https://readdy.ai/api/search-image?query=dynamic%20speed%20and%20performance%20visualization%20with%20motion%20blur%20effects%20and%20neon%20yellow-green%20accents%2C%20dark%20background%20with%20glowing%20elements%20showing%20optimization%20concept%2C%20modern%20abstract%20tech%20design&width=360&height=240&seq=feature-performance&orientation=landscape'
    },
    {
      title: 'Smart Device Cleaning',
      label: 'Optimization',
      description: 'Intelligent algorithms to keep your device running smoothly',
      image: 'https://readdy.ai/api/search-image?query=clean%20iOS%20mobile%20interface%20showing%20storage%20optimization%20and%20cleaning%20features%20with%20circular%20progress%20bars%2C%20modern%20app%20screenshot%20with%20white%20background%20and%20green%20accent%20colors%2C%20professional%20mobile%20application%20design&width=360&height=240&seq=feature-cleaning&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-16">
          <div className="space-y-4">
            <h2 className="text-5xl font-bold text-gray-400">Powerful</h2>
            <h2 className="text-5xl font-bold italic text-gray-900">Capabilities</h2>
          </div>
          
          <div>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our applications are built with cutting-edge technology and innovative features that set them apart. Every feature is carefully designed to provide maximum value and exceptional user experience.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 p-8"
            >
              <div className="w-full h-[240px] rounded-xl overflow-hidden mb-6 bg-gray-100">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="inline-block px-4 py-2 bg-lime-400 text-gray-900 text-xs font-bold tracking-wider rounded-full uppercase mb-4">
                {feature.label}
              </span>
              <h3 className="text-2xl font-bold text-gray-900 mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
